export default __webpack_public_path__ + "bb8e9f72e09c087228f9948a8434b84e.png";